import React from 'react';

/**
 * Section 3 : Personnes à contacter
 */
const AssessmentSection3_Contacts = ({ data, onChange }) => {
  const handleChange = (section, field, value) => {
    onChange('contacts', {
      ...data,
      [section]: {
        ...data[section],
        [field]: value
      }
    });
  };

  return (
    <div className="assessment-section-content">
      <h3 className="assessment-section-title">PERSONNES À CONTACTER</h3>
      <p className="assessment-section-description">
        Identifiez les personnes de confiance et l'entourage du bénéficiaire.
      </p>

      {/* Personne de confiance */}
      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: '16px' }}>
        Personne de confiance
      </h4>

      <div className="assessment-form-group">
        <label>Avez-vous désigné une personne de confiance ?</label>
        <div className="assessment-radio-group">
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="trustedPersonExists"
              checked={data?.trustedPerson?.exists === false}
              onChange={() => handleChange('trustedPerson', 'exists', false)}
            />
            <span>Non</span>
          </label>
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="trustedPersonExists"
              checked={data?.trustedPerson?.exists === true}
              onChange={() => handleChange('trustedPerson', 'exists', true)}
            />
            <span>Oui</span>
          </label>
        </div>
      </div>

      {data?.trustedPerson?.exists && (
        <>
          <div className="assessment-form-group">
            <label>Nom et prénom</label>
            <input
              type="text"
              className="assessment-form-control"
              value={data?.trustedPerson?.name || ''}
              onChange={(e) => handleChange('trustedPerson', 'name', e.target.value)}
            />
          </div>

          <div className="assessment-form-group">
            <label>Lien avec vous</label>
            <select
              className="assessment-form-control"
              value={data?.trustedPerson?.relationship || ''}
              onChange={(e) => handleChange('trustedPerson', 'relationship', e.target.value)}
            >
              <option value="">-- Sélectionner --</option>
              <option value="famille">Famille</option>
              <option value="ami">Ami(e)</option>
              <option value="voisin">Voisin(e)</option>
              <option value="autre">Autre</option>
            </select>
          </div>

          <div className="assessment-grid-2">
            <div className="assessment-form-group">
              <label>Téléphone</label>
              <input
                type="tel"
                className="assessment-form-control"
                value={data?.trustedPerson?.phone || ''}
                onChange={(e) => handleChange('trustedPerson', 'phone', e.target.value)}
              />
            </div>

            <div className="assessment-form-group">
              <label>Email</label>
              <input
                type="email"
                className="assessment-form-control"
                value={data?.trustedPerson?.email || ''}
                onChange={(e) => handleChange('trustedPerson', 'email', e.target.value)}
              />
            </div>
          </div>
        </>
      )}

      {/* Personne à prévenir en cas d'urgence */}
      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '32px', marginBottom: '16px' }}>
        Personne à prévenir en cas d'urgence
      </h4>

      <div className="assessment-form-group">
        <label>Nom et prénom</label>
        <input
          type="text"
          className="assessment-form-control"
          value={data?.emergencyContact?.name || ''}
          onChange={(e) => handleChange('emergencyContact', 'name', e.target.value)}
        />
      </div>

      <div className="assessment-form-group">
        <label>Lien avec vous</label>
        <input
          type="text"
          className="assessment-form-control"
          value={data?.emergencyContact?.relationship || ''}
          onChange={(e) => handleChange('emergencyContact', 'relationship', e.target.value)}
        />
      </div>

      <div className="assessment-grid-2">
        <div className="assessment-form-group">
          <label>Téléphone 1</label>
          <input
            type="tel"
            className="assessment-form-control"
            value={data?.emergencyContact?.phone1 || ''}
            onChange={(e) => handleChange('emergencyContact', 'phone1', e.target.value)}
          />
        </div>

        <div className="assessment-form-group">
          <label>Téléphone 2</label>
          <input
            type="tel"
            className="assessment-form-control"
            value={data?.emergencyContact?.phone2 || ''}
            onChange={(e) => handleChange('emergencyContact', 'phone2', e.target.value)}
          />
        </div>
      </div>

      {/* Entourage familial et social */}
      <h4 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '32px', marginBottom: '16px' }}>
        Entourage familial et social
      </h4>

      <div className="assessment-form-group">
        <label>Avez-vous de la famille proche ?</label>
        <div className="assessment-radio-group">
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasCloseFamily"
              checked={data?.familySupport?.hasCloseFamily === false}
              onChange={() => handleChange('familySupport', 'hasCloseFamily', false)}
            />
            <span>Non</span>
          </label>
          <label className="assessment-radio-label">
            <input
              type="radio"
              name="hasCloseFamily"
              checked={data?.familySupport?.hasCloseFamily === true}
              onChange={() => handleChange('familySupport', 'hasCloseFamily', true)}
            />
            <span>Oui</span>
          </label>
        </div>
      </div>

      {data?.familySupport?.hasCloseFamily && (
        <div className="assessment-form-group">
          <label>Précisez (enfants, frères/sœurs, autres)</label>
          <textarea
            className="assessment-form-control"
            rows="3"
            value={data?.familySupport?.familyMembers || ''}
            onChange={(e) => handleChange('familySupport', 'familyMembers', e.target.value)}
          />
        </div>
      )}

      <div className="assessment-form-group">
        <label>Fréquence des contacts</label>
        <select
          className="assessment-form-control"
          value={data?.familySupport?.contactFrequency || ''}
          onChange={(e) => handleChange('familySupport', 'contactFrequency', e.target.value)}
        >
          <option value="">-- Sélectionner --</option>
          <option value="quotidiens">Quotidiens</option>
          <option value="hebdomadaires">Hebdomadaires</option>
          <option value="mensuels">Mensuels</option>
          <option value="rares">Rares</option>
          <option value="aucun">Aucun</option>
        </select>
      </div>

      <div className="assessment-form-group">
        <label>Bénéficiez-vous d'un soutien familial ?</label>
        <select
          className="assessment-form-control"
          value={data?.familySupport?.supportLevel || ''}
          onChange={(e) => handleChange('familySupport', 'supportLevel', e.target.value)}
        >
          <option value="">-- Sélectionner --</option>
          <option value="important">Oui, important</option>
          <option value="modere">Oui, modéré</option>
          <option value="faible">Faible</option>
          <option value="aucun">Aucun</option>
        </select>
      </div>

      <div className="assessment-form-group">
        <label>Avez-vous des amis, voisins, relations sociales régulières ?</label>
        <select
          className="assessment-form-control"
          value={data?.socialNetwork?.frequency || ''}
          onChange={(e) => handleChange('socialNetwork', 'frequency', e.target.value)}
        >
          <option value="">-- Sélectionner --</option>
          <option value="frequemment">Oui, fréquemment</option>
          <option value="occasionnellement">Oui, occasionnellement</option>
          <option value="rarement">Rarement</option>
          <option value="non">Non</option>
        </select>
      </div>
    </div>
  );
};

export default AssessmentSection3_Contacts;
